import React from 'react';
import Header from './Header';
import contacts from '../json/contacts.json';

import linkedin from '../assets/ic_linkedin.png';
import twitter from '../assets/ic_twitter.png';
import whatsapp from '../assets/ic_whatsapp.png';
import github from '../assets/ic_github.png';
import envelope from '../svgs/envelope.svg';
import location from '../svgs/location.svg';
import phone from '../svgs/phone.svg';

function Contact() {
	const icons = [linkedin, twitter, whatsapp, github, envelope, envelope, location, phone, phone, phone];
	return (
		<React.Fragment>
			<Header appTitle="Contact" />
			<div className="main-body contacts-page pd-md-v xl-pd-none">
				<div className="sp-lg-bottom">
					<h4>Below are some of the places you can find me. Click any of the links to reach me between 06:00 - 22:00, any day of the week.</h4>
				</div>
				<div className="contacts grid sm-grid-2">
					{contacts.map((contact, index) => (
						<a key={index} target="_blank" rel="noreferrer" href={contact.url}>
							<div className="each-contact elevate flex align-center ">
								<div className="icon flex align-center justify-center ovf-hidden">
									<img className="rad-sm" src={icons[index]} alt={contact.media} />
								</div>
								<div className="pd">
									<h4 className="txt-primary">{contact.media}</h4>
									<p className="font-md txt-default">{contact.name}</p>
								</div>
							</div>
						</a>
					))}
				</div>
				<div className="sp-xl-top pd-md-h blob-t blob-b txt-fade">
					<p className="">When contacting using any of the provided platform, please you are advised to be formal. Any form of spam might cause unwanted results and consequences.</p>
				</div>
			</div>
		</React.Fragment>
	);
}

export default Contact;
